import type { ComponentProps } from "react";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

type Loader2Props = ComponentProps<typeof Skeleton>;

export function Loader2({ className, ...props }: Loader2Props) {
  const resolvedClassName = className?.replace(/\banimate-spin\b/g, "").trim();
  return <Skeleton className={cn("animate-pulse", resolvedClassName)} {...props} />;
}
